
import {z} from "zod";
import { AISystemImpact, InternalImpact, ExternalImpact } from "../../risk/AISystemImpact";
import type { AssertSchemaMatchesClass } from "../../../utils/typeUtils";
import { HarmSchema } from "./Harm.schema";
import { Harm } from "../Harm";


const _InternalImpactZod = z.object({
  financial: HarmSchema.default(new Harm()),
  reputational: HarmSchema.default(new Harm()),
  legal: HarmSchema.default(new Harm()),
  operational: HarmSchema.default(new Harm()),
});
// Assert that schema matches the class definition
void (true as AssertSchemaMatchesClass<typeof _InternalImpactZod, InternalImpact>);
export const InternalImpactSchema = _InternalImpactZod.transform((data) => new InternalImpact(data));

const _ExternalImpactZod = z.object({
  people: HarmSchema.default(new Harm()),
  organisations: HarmSchema.default(new Harm()),
  ecosystems: HarmSchema.default(new Harm()),
});
// Assert that schema matches the class definition
void (true as AssertSchemaMatchesClass<typeof _ExternalImpactZod, ExternalImpact>);
export const ExternalImpactSchema = _ExternalImpactZod.transform((data) => new ExternalImpact(data));



const _AISystemImpactZod = z.object({
  internal: InternalImpactSchema.default(new InternalImpact()),
  external: ExternalImpactSchema.default(new ExternalImpact())
});
// Assert that schema matches the class definition
void (true as AssertSchemaMatchesClass<typeof _AISystemImpactZod, AISystemImpact>);
export const AISystemImpactSchema = _AISystemImpactZod.transform((data) => new AISystemImpact(data));

